import { Component, ElementRef, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonService } from '../../services/common.service';
import { AppModule } from '../../utilities/app/app.module';
import { DomSanitizer } from '@angular/platform-browser';
import { setTimeout } from 'timers/promises';
import { ApiService } from '../../services/api.service';
import { SearchService } from './search-service';
import { Route, Router } from '@angular/router';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-search',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, AppModule],
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss',
})

export class SearchComponent implements OnInit {

  results_populated_or_error = new EventEmitter();

  constructor(public commonservice: CommonService,
    public searchService: SearchService,
    private sanitizer: DomSanitizer,
    private hostRef: ElementRef,
    private messageService: MessageService,
    private apiService: ApiService,
    private router: Router) { }

  @Output()
  is_search_clicked = new EventEmitter();

  @Output()
  searched_terms = new EventEmitter();

  show_filter_button = false;

  corporas: any;
  selected_corpora: any;
  corpus_name = 'Demo V2';

  search_fields_menu = [
    // {
    //   label: 'Transcript Search',
    //   command: ($event: any) => {
    //     this.add_new_filter($event.item.label, $event.item.id);
    //   },
    // },
    {
      label: 'Speech Search',
      id: 'speech_criterias',
      command: ($event: any) => {
        this.add_new_filter($event.item.label, $event.item.id);
      },
    },
    {
      label: 'OCR Search',
      id: 'ocr_criterias',
      command: ($event: any) => {
        this.add_new_filter($event.item.label, $event.item.id);
      }
    }
  ]

  ngOnInit(): void {
    // this.apiService.list_all_corpora().subscribe({
    //   next: (corpora: any) => {
    //     try {
    //       let keys = Object.keys(corpora);
    //       this.corporas = []
    //       keys.forEach((key: string) => {
    //         let corp_obj = {
    //           name: key,
    //           value: corpora[key]
    //         }
    //         this.corporas = [...this.corporas, corp_obj]
    //         this.selected_corpora = this.corporas.filter((corp: any) => corp.name == this.corpus_name)[0];
    //       })
    //     } catch (err: any) {
    //       if (err.status == 401) {
    //         this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please Login again' });
    //         this.router.navigate(['/logout']);
    //         return;
    //       } else {
    //         this.messageService.add({ severity: 'error', summary: 'Error occured', detail: `status code: ${err.status}` });
    //         return;
    //       }
    //     }
    //   },
    //   error: (err: any) => {
    //     this.messageService.add({ severity: 'error', summary: 'Error occured', detail: `status code: ${err.status}` });
    //     return;
    //   }
    // });
  }



  search_term_for_videos() {
    if (this.searchService.search_term.length < 3) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please enter at least 3 characters to search' });
      return
    }
    this.commonservice.video_data = {};
    this.is_search_clicked.emit(true);
    let all_search_terms = document.getElementsByClassName('search_input_additional_filter');
    let search_obj: any = {};
    for (var i = 0; i < all_search_terms.length; i++) {
      let obj = {
        type: all_search_terms[i].id,
        value: (<HTMLInputElement>all_search_terms[i]).value
      }
      if (search_obj && search_obj[obj.type]) {
        search_obj[obj.type] = [...search_obj[obj.type], obj.value]
      } else {
        search_obj[obj.type] = [obj.value]
      }
    }

    if (!this.selected_corpora) {
      let demo_corporas: any = {
        "Demo": {
          id: "projects/443684771622/locations/us-central1/corpora/2603701731499657403"
        },
        "Demo V2": {
          id: "projects/443684771622/locations/us-central1/corpora/1220397490053533204"
        }
      }
      this.selected_corpora = demo_corporas[this.corpus_name]
    }

    let body = {
      corpus_id: this.selected_corpora.id,
      corpus_name: this.corpus_name,
      text_query: this.searchService.search_term,
      ocr_criterias: [],
      speech_criterias: []
    }

    if (search_obj?.ocr_criterias) {
      body['ocr_criterias'] = search_obj?.ocr_criterias
    }

    if (search_obj?.speech_criterias) {
      body['speech_criterias'] = search_obj?.speech_criterias
    }

    this.apiService.search_moments(body).subscribe({
      next: (res: any) => {
        let search_terms: any = body;

        search_terms['corpora'] = this.selected_corpora

        this.searched_terms.emit(search_terms);
        this.searchService.all_search_terms = search_terms;
        this.searchService.is_search_clicked.next(true);

        if (res) {
          if (res.length == 0) {
            this.commonservice.video_data = {}
          } else {
            this.commonservice.video_data = {}
            if (JSON.stringify(res) == "{}") {
              this.commonservice.video_data = {}
            } else {
              this.commonservice.video_data = res;
              this.searchService.is_search_clicked.next(true);
              this.results_populated_or_error.emit(true);
              // res.forEach((asset: any) => {
              //   let asset_pubic_url = asset.public_url + "#t=" + asset.segment.start_time_seconds + "," + asset.segment.end_time_seconds
              //   if (!this.commonservice.video_data) {
              //     this.commonservice.video_data = {}
              //   }
              //   let name = asset.name.split("-Part")[0]
              //   if (this.commonservice.video_data[name]) {
              //     this.commonservice.video_data[name] = [...this.commonservice.video_data[name], { id: asset.uuid, url: asset_pubic_url, uploaded_time: asset.uploaded_time }];
              //   } else {
              //     this.commonservice.video_data[name] = [{ id: asset.uuid, url: asset_pubic_url, uploaded_time: asset.uploaded_time }];
              //   }
              // });
            }
            this.show_filters();
          }
        } else {
          this.commonservice.video_data = {}
        }
      },
      error: (err: any) => {
        if (err.status == 401) {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please Login again' });
          this.router.navigate(['/logout']);
          this.results_populated_or_error.emit(true);
          return;
        } else {
          let summary = "Failed to get Results"
          if (err.status == 0) {
            err.status = 503
            summary = "Service Unavailable"
          }
          this.messageService.add({ severity: 'error', summary: summary, detail: `status code: ${err.status}` });
        }
        this.searchService.is_search_clicked.next(true);
        this.results_populated_or_error.emit(true);
      }
    });
  }

  checkif_empty() {
    if (this.searchService.all_search_terms.text_query === '') {
      this.commonservice.video_data = {};
    }
  }

  add_new_filter(label: any, id: any) {
    let dropdownHtml = this.sanitizer.bypassSecurityTrustHtml(
      `<span class='p-float-label inline_display_for_delete'>
        <input id="${id}" type="text" (keyup.space)="display_chips($event)" class="p-inputtext p-component p-element search_input_additional_filter" placeholder="${label}" pInputText/>
      </span>`
    );
    if (this.searchService.dropdowns == undefined) {
      this.searchService.dropdowns = [dropdownHtml]
    } else {
      this.searchService.dropdowns.push(dropdownHtml);
    }
    this.searchService.show_filter_button = false;
  }

  show_filters() {
    this.searchService.show_filter_button = true;
  }

  filterer: any[] = [];

  display_chips(event: any) {
    this.filterer.push(event);
  }

  remove() {
    this.searchService.dropdowns.pop();
  }

}
